import React, { useState, useEffect } from "react";
import i18n from "../i18n.js";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import { useForm } from "react-hook-form";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import Container from "@mui/material/Container";
import axios from "axios";
import { parse, compareAsc } from "date-fns";
import Autocomplete from "@mui/material/Autocomplete";

// import { FormContainer, TextFieldElement } from "react-hook-form-mui";

const Person = (props) => {
    // eslint-disable-next-line react/prop-types
    const { itemOptions } = props;
    const { api, comp } = itemOptions;
    const { t } = i18n;
    const navigate = useNavigate();

    let { state } = useLocation();
    let { code: tmpCode } = useParams();

    const [loading, setLoading] = useState(true);
    const [person, setPerson] = useState([]);
    const [options, setOptions] = useState([]);
    const [code, setCode] = useState("");
    const [chosen, setChosen] = useState(null);

    const onClick = () => {
        if (chosen !== null) {
            navigate("/events", {
                state: {
                    person: chosen,
                    fromPzst: true,
                    code: code,
                },
            });
        }
    };

    useEffect(() => {
        let tmpOptions = [];
        let code2 = "";
        if (state !== undefined && state !== null) {
            // setCode(state.code);
            code2 = state.code;
        }
        if (tmpCode !== undefined && tmpCode !== null) {
            // setCode(tmpCode);
            code2 = tmpCode;
        }
        if (comp.status.registrationOpen === false && code2 === "") {
            navigate("/");
            // console.log("navigate to root");
        } else if (comp.status.registrationOpen === false && code2 !== "") {
            axios
                .put(`${api.checkCode}${comp.id}`, { code: code2 })
                .then((res) => {
                    if (res.status === 200) {
                        setCode(code2);
                    } else {
                        navigate("/");
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    navigate("/");
                });
        }
        axios.get(`${api.apiGetPerson}`).then((res) => {
            const p = res.data;
            setPerson(p);
            if (p.sedzia !== null) {
                tmpOptions.push(p.sedzia);
            }
            p.athletes.forEach((a) => {
                tmpOptions.push(a);
            });
            setOptions(tmpOptions);
        });
        setLoading(false);
    }, []);
    // console.log(chosen);
    return (
        <React.Fragment>
            <hr />
            <h2 className="display-6 mt-2">{t("reg.pzst.people")}</h2>
            <p>{t("reg.info.participants")}</p>

            <Container maxWidth="xs" className="mb-2">
                <Box>
                    <form>
                        <Stack direction="column" spacing={{ xs: 1, sm: 1, md: 4 }}>
                            {!loading && (
                                <Autocomplete
                                    id="startersSelect"
                                    options={options?.sort((a, b) => a.fullName.localeCompare(b.fullName))}
                                    groupBy={(option) => t(option.type)}
                                    getOptionLabel={(option) => option.fullName}
                                    value={chosen}
                                    onChange={(event, newValue) => {
                                        setChosen(newValue);
                                    }}
                                    // sx={{ width: 300 }}
                                    renderInput={(params) => <TextField {...params} label={t("reg.pzst.choose_starter")} />}
                                />
                            )}
                            {!loading && (
                                <Button type="submit" variant="contained" onClick={onClick} startIcon={<HowToRegIcon />} fullWidth disabled={chosen === null}>
                                    {t("reg.wdsf.continue")}
                                </Button>
                            )}
                            {loading && <LinearProgress />}
                        </Stack>
                    </form>
                </Box>
            </Container>
        </React.Fragment>
    );
};

export default Person;
